// istanbul ignore file
import { get } from 'lodash-es';
import { Observable, timer } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dataToObservable<T>(data: any, path: string): Observable<T> {
  return new Observable<T>((subscriber) => {
    const subscription = timer(0, 100).subscribe(() => {
      // console.log('checking',data, data.status(), data.fetchStatus(), data.isPending(), data.isLoading());
      if (data.fetchStatus() === 'idle' && data.status() === 'success') {
        subscriber.next(get(data.data(), path) as T);
        subscriber.complete();
        subscription.unsubscribe();
      } else if (data.status() === 'error') {
        subscriber.error(data.error());
        subscription.unsubscribe();
      }
    });
    return () => subscription.unsubscribe();
  });
}